module.exports = __webpack_public_path__ + "static/media/login-restaurant.c8a454ed.svg";